import IMyCourseResponse from "../client/models/myCourse/IMyCourseResponse";
import ILesson from "../client/models/myCourse/ILesson";
import {createLessonUrl} from "./lessonPageFactory";
import ICard from "../models/view/common/ICard";
import ICourseLessonsPage from "../models/view/courseLessonsPage/ICourseLessonsPage";
import {createCourseLessonUrl} from "./coursesPageFactory";
import {miscImages} from "../config/config";
import {DifficultyOption} from "../models/view/common/DifficultyOption";
import ISection from "../client/models/myCourse/ISection";
import {ISectionModel} from "../models/view/bootCampPage/IBootCampPageModel";

export function createCourseLessonsPageViewModel(courseResponse: IMyCourseResponse, courseId: number, hasModalBeenDisplayedForTheFirstTime: boolean): ICourseLessonsPage{
  let lessons: ILesson[] = [];
  courseResponse.sections?.forEach(function(section) {
    lessons = lessons.concat(section.lessons);
  });

  const sectionModels = courseResponse?.sections?.map(function(s: ISection) {
    return <ISectionModel>{
      id: s.id,
      name: s.name,
      description: s.description,
      cards: s.lessons ? createCourseLessonCards(courseId, s.lessons) : [],
      isComplete: s.isComplete,
      courseId: courseId
    };
  }) ?? [];

  return {
    courseId: courseResponse.course.id,
    courseName: courseResponse.course.name,
    courseLessonCards: createCourseLessonCards(courseId, lessons),
    isLoading: false,
    isModalVisible: !hasModalBeenDisplayedForTheFirstTime,
    courseDescription: courseResponse.course.description ? courseResponse.course.description  : "The course description will look something like this.  Initially it will be limited to a single paragraph with no formatting for new lines, lists, bold text, etc.  Be careful not to put too much text though, as there is no scrolling on this.",
    courseImageUrl: courseResponse.course.imageUrl ? courseResponse.course.imageUrl : miscImages.genericCourse,
    showLessonNumbers: courseResponse.course.showLessonNumbers,
    areSectionsEnabled: courseResponse.course.areSectionsEnabled,
    sections: sectionModels
  };
}

export const createInitialViewModel = (): ICourseLessonsPage  => ({
  courseId: 0,
  sections: [],
  courseName: "",
  courseLessonCards: [],
  isLoading: true,
  isModalVisible: false,
  courseImageUrl: "",
  courseDescription: "",
  showLessonNumbers: true,
  areSectionsEnabled: false,
});

function createCourseLessonCards(courseId: number, courseLessons: ILesson[]){
  return courseLessons.map((l, index) => createCourseLessonCard(courseId, l, index + 1));
}

function createCourseLessonCard(courseId: number, courseLesson: ILesson, number: number): ICard{
  const relativeUrl = createLessonUrl(courseLesson.id, undefined, courseId, undefined, createCourseLessonUrl(courseId));

  return {
    // courseId,
    imageUrl: courseLesson.image,
    // lessonId: courseLesson.id,
    title: courseLesson.name,
    subText: courseLesson.subtext,
    relativeUrl,
    number: number.toString(),
    icon: courseLesson.icon,
    cardType: "course-lesson",
    isComplete: courseLesson.isComplete,
    isStarted: courseLesson.quantityCompleted > 0,
    amountComplete: `${courseLesson.quantityCompleted}/${courseLesson.quantitySegments}`,
    difficultyCategory: courseLesson.difficulty.toLowerCase() as DifficultyOption,
  };
}
